var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center dark my-2"},[_c('b-spinner',{staticClass:"align-middle mr-2"}),_c('strong',[_vm._v(" "+_vm._s(_vm.$t('components.doinsport.table.loading'))+" ...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }